var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.$route.meta.layout || _vm.layout,{tag:"component",attrs:{"fullScreen":_vm.$route.meta.layoutFull || false,"showMenu":_vm.$route.meta.showMenu}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }